import {AvailableSlotsResponse, SingleSlotParams} from '@hconnect/tuc-processes/slotManagement'
import {AxiosRequestHeaders} from 'axios'

import {api} from '../../../../../../../../App.global'

/**
 * Fetches available delivery time slots from the backend.
 *
 * @param params - Slot query parameters (customer, site, date, etc.)
 * @returns Available slots response with slot times and availability info
 */
export const fetchAvailableSlots = async (
  params: SingleSlotParams | null
): Promise<AvailableSlotsResponse> => {
  if (!params) return {availableSlots: []}
  const config = {
    params,
    headers: {} as AxiosRequestHeaders
  }
  const response = await api.get<AvailableSlotsResponse>(`/rmcSlots/available`, config)
  const {data} = response
  return data
}

/**
 * Creates a React Query configuration for fetching available time slots.
 *
 * This factory function returns a query configuration object that can be used with
 * useQuery or similar hooks. It includes standard cache settings and retry behavior.
 *
 * @param params - Slot query parameters
 * @returns Query configuration object with queryKey, queryFn, and query options
 *
 * @example
 * const { availableSlots, queryInfo } = useAvailableTimeSlots({
 *   dateIndex: 0,
 *   slotAvailabilityQueryFn: createAvailableSlotsQueryConfig
 * });
 */
export const createAvailableSlotsQueryConfig = (params: SingleSlotParams) => ({
  queryKey: ['available-slots', params],
  queryFn: () => fetchAvailableSlots(params),
  enabled: true,
  refetchInterval: 90 * 1000, // Refetch every 90 seconds
  cacheTime: 90 * 1000,
  staleTime: 90 * 1000,
  retry: 0
})
